import { useMemo } from "react";
import DeleteDocumentationModal from "./delete-documentation-modal";
import { UploadDocumentationModal } from "./upload-documentation-modal";
import { emDashUnicode } from "../../../../../../constants/constants";
import AttachmentDownload from '@/pages/ReviewDetails/Attachment/AttachmentDownload/AttachmentDownload';

  const uploadTableColumns = [
    {
      Header: 'File name',
      accessor: 'filename',
      sortable: false,
      Cell: ({ row: { original } }) => {
        return (
          <AttachmentDownload
            name={original?.name}
            metadataId={original?.metadataId}
          />
        );
      },
    },
    {
      Header: 'Note',
      accessor: 'note',
      sortable: false,
      cellClassName: 'attachment-note',
      Cell: ({ row: { original } }) => {
        return original?.description || emDashUnicode;
      },
    },
  ];

export default function generateAdditionalRequirementForm({
    requirement,
    attachmentTypes,
    handleUpload,
    handleSave,
    handleDelete,
    saving,
    uploading,
    deleting,
    handleEditAction,
    handleDeleteAction,
    index,
}) {
    const defaultValues = useMemo(() => ({
        [`id-${index}`]: requirement?.requisitionAdditionalRequirementId || '',
        [`description-${index}`]: requirement?.description || '',
        [`hasSupportingDocumentation-${index}`]: requirement?.attachments?.length > 0 || false,
        [`files-${index}`]: (requirement?.attachments || []).map(attachment => ({
            ...attachment,
            note: attachment.description,
            category: attachment.attachmentTypeId,
            id: attachment.requisitionAttachmentId,
        })) || [],
        [`priceEstimate-${index}`]: requirement?.priceEstimate || ''
    }), [])

    const content = {
        buttonControls: {
            submit: false,
            cancel: false,
        },
        sections: [
            {
                className: 'areq-requirement-form',
                gap: '50px',
                fields: [
                    {
                        id: `description-${index}`,
                        type: 'textarea',
                        label: 'Enter a description of your additional requirement',
                        required: true,
                        columnWidth: 'col-12-12',
                        element: {
                            control: {
                                autoGrow: true,
                                maxLength: 100,
                                style: {
                                    width: '100%',
                                    maxWidth: '100%',
                                }
                            }
                        }
                    },
                    {
                        dependentOn: `files-${index}`,
                        dependentWaitType: 'disabled',
                        dependentValue: (val) => val?.length === 0,
                        id: `hasSupportingDocumentation-${index}`,
                        type: 'checkbox',
                        label: 'Supporting documents',
                    },
                    {
                        dependentOn: `hasSupportingDocumentation-${index}`,
                        dependentWaitType: 'hidden',
                        id: `files-${index}`,
                        type: 'file-table-upload',
                        element: {
                            control: {
                                tableHeader: <h3 style={{ margin: 0, padding: 0, }}>Supporting documentation</h3>,
                                uploadModal: UploadDocumentationModal,
                                uploadModalProps: {
                                    attachmentTypes,
                                },
                                confirmDeleteModal: DeleteDocumentationModal,
                                handleUpload,
                                handleSave,
                                handleDelete,
                                savingState: saving,
                                uploadingState: uploading,
                                deletingState: deleting,
                                tableActions: [
                                {
                                    icon: 'edit',
                                    label: 'Edit file documentation',
                                    handler: handleEditAction,
                                },
                                {
                                    icon: 'delete',
                                    label: 'Delete file',
                                    handler: handleDeleteAction,
                                },
                                ],
                                tableColumns: uploadTableColumns,
                            }
                        }
                    },
                    {
                        id: `priceEstimate-${index}`,
                        type: 'currency',
                        label: 'Price estimate from Independent Government Cost Estimate (IGCE)',
                        required: true,
                        element: {
                            label: {
                                style: {
                                    maxWidth: '100%',
                                }
                            },
                            control: {
                                style: {
                                    width: '160px'
                                }
                            }
                        }
                    }
                ]
            }
        ]
    }

    return [defaultValues, content]
}